import symbol from "./symbol.js";
import symbolDS4 from "./symbol[ds-4].js";
<ebay-icon ...input _name="carousel-prev" _type="icon" _themes=[symbol, symbolDS4]/>
